import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/esm/Col';

function AdministratorCard({
  administrator,
  chosenAdminId,
  chosenAdmin,
  onDelete,
  onEdit,
}) {
  return (
    <Card>
      <Card.Body>
        <Col className='d-none flex-column d-sm-flex'>
          <div className='d-flex align-items-center'>
            <h3>
              {administrator?.firstName} {administrator?.lastName}
            </h3>
          </div>
          <div className='d-flex bg-divider align-items-center justify-content-between'>
            <span className=''>E-post</span>
            <span>{administrator?.email}</span>
          </div>
        </Col>
        <Col className='d-flex flex-column d-sm-none'>
          <div className='d-flex align-items-center'>
            <h3>
              {administrator?.firstName} {administrator?.lastName}
            </h3>
          </div>
          <div className='d-flex bg-divider align-items-center'>
            <span className='text-truncate'>{administrator?.email}</span>
          </div>
        </Col>

        <Card.Footer className='mt-4'>
          <div className='d-flex gap-5 justify-content-between'>
            <div
              className='d-flex gap-2 justify-content-end'
              role='button'
              onClick={() => {
                chosenAdminId(administrator?.id);
                onDelete();
              }}
            >
              <span className='material-symbols-outlined'>delete</span>
              <span>Radera</span>
            </div>
            <Button
              variant='outline-primary'
              className='py-0 px-3'
              onClick={() => {
                chosenAdmin(administrator);
                onEdit();
              }}
            >
              Redigera
            </Button>
          </div>
        </Card.Footer>
      </Card.Body>
    </Card>
  );
}

export default AdministratorCard;
